import React, { FunctionComponent } from 'react'

import { useField } from 'formik'
import { SpaceProps, WidthProps } from 'styled-system'

import { TextAreaInput } from '@/atoms/input'

import FieldWrapper from './field-wrapper'

export interface TextareaProps {
  label?: string
  fieldProps?: SpaceProps & WidthProps
  name?: string
  placeholder?: string
  hideErrorMessage?: boolean
  isDisabled?: boolean
  tooltip?: string
}

const TextAreaField: FunctionComponent<TextareaProps> = ({
  label,
  fieldProps,
  name,
  placeholder,
  isDisabled,
  hideErrorMessage,
  tooltip,
}: TextareaProps) => {
  const [field, meta] = useField(name)
  const hasError: boolean = meta.touched && !!meta.error

  return (
    <FieldWrapper id={field.name} meta={meta} label={label} fieldProps={fieldProps} hideErrorMessage={hideErrorMessage} tooltip={tooltip}>
      <TextAreaInput id={field.name} hasError={hasError} value={field.value} placeholder={placeholder} isDisabled={isDisabled} {...field} />
    </FieldWrapper>
  )
}

TextAreaField.displayName = 'TextAreaField'

export default TextAreaField
